import { scrollToHash } from "@/utils/hours";
import { INFO } from "@/data/content";

const LINKS = [
  { href: "#storia", label: "Chi Siamo" },
  { href: "#menu", label: "Menu" },
  { href: "#recensioni", label: "Recensioni" },
  { href: "#galleria", label: "Galleria" },
  { href: "#contatti", label: "Contatti" },
];

export const Footer = () => (
  <footer className="border-t border-sand/10 bg-espresso pb-10 pt-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-sand">
            Bar Incontro · Pesaro
          </p>
          <p className="mt-5 max-w-sm font-serif text-xl italic leading-snug text-cream/60">
            "Un punto di incontro per ogni momento della tua giornata."
          </p>
        </div>

        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-sand">
            Esplora
          </p>
          <ul className="mt-5 space-y-3">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToHash(l.href);
                  }}
                  className="text-sm text-cream/65 transition-colors duration-300 hover:text-cream"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-sand">
            Contatti & Orari
          </p>
          <ul className="mt-5 space-y-3 text-sm text-cream/65">
            <li>{INFO.address}</li>
            <li>
              <a
                href={INFO.phoneHref}
                data-testid="footer-phone-link"
                className="font-mono transition-colors duration-300 hover:text-cream"
              >
                {INFO.phoneDisplay}
              </a>
            </li>
            <li>Lun - Sab 6:30 - 00:00</li>
            <li>Domenica: 7:30 – 00:00</li>
            <li>Martedì: chiuso</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex justify-center">
        <img
          src="/photos/logo.png"
          alt="Bar Incontro — logo ufficiale"
          data-testid="footer-official-logo"
          loading="lazy"
          className="w-full max-w-md rounded-2xl border border-sand/10"
        />
      </div>

      <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-sand/10 pt-6 text-xs text-cream/40">
        <p>© {new Date().getFullYear()} Bar Incontro · Pesaro</p>
        <p className="font-mono">{INFO.plusCode}</p>
      </div>
    </div>
  </footer>
);
